import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import FooterContacto from './components/FooterContacto';

// Lazy loading de páginas
const Inicio = lazy(() => import('./pages/Inicio'));
const Servicios = lazy(() => import('./pages/Servicios'));
const Quienes = lazy(() => import('./pages/Quienes'));
const Contacto = lazy(() => import('./pages/Contacto'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <Router>
      <Navbar />
      <Suspense fallback={<div className="loading">Cargando...</div>}>
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/quienes" element={<Quienes />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <FooterContacto />
    </Router>
  );
}

export default App;
